import script from "./VerifyOnetimePasscode.vue?vue&type=script&setup=true&lang=ts"
export * from "./VerifyOnetimePasscode.vue?vue&type=script&setup=true&lang=ts"

import "../main/mypage/mypage.css?vue&type=style&index=0&id=6d1645e8&scoped=true&lang=css"
import "./modal.css?vue&type=style&index=1&id=6d1645e8&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d1645e8"]])

export default __exports__